/**
 * CR508: FeedbackBlock
 *
 * Renders feedback control inside the card when the feedback block is enabled.
 */

import React from "react";
import type { DealCardBlockProps } from "@/lib/deal-cards/specV2/types";
import type { Deal } from "@/lib/types/deals";
import { DealFeedbackWidget } from "@/components/deals/DealFeedbackWidget";
import { useDealFeedback } from "@/hooks/useDealFeedback";

interface FeedbackConfig {
  pendingLabel?: string;
  positiveLabel?: string;
  negativeLabel?: string;
}

export const FeedbackBlock: React.FC<DealCardBlockProps<Deal>> = ({ deal, block, context }) => {
  const config = (context.components?.feedback ?? {}) as FeedbackConfig;
  const dedupeKey = (deal as Deal & { dedupe_key?: string; id?: string }).dedupe_key ?? (deal as Deal & { id?: string }).id;
  const feedback = useDealFeedback({
    dealDedupeKey: dedupeKey,
    dealId: (deal as Deal & { id?: string }).id ?? null,
    source: context.isAdmin ? "admin_preview" : "site",
    enabled: !context.isAdmin && block.enabled,
  });

  if (!block.enabled) {
    return null;
  }

  return (
    <div
      className="mt-3"
      data-block="feedback"
      data-block-id={block.id}
      data-component-key="feedback"
    >
      <DealFeedbackWidget
        pendingLabel={config.pendingLabel}
        positiveLabel={config.positiveLabel}
        negativeLabel={config.negativeLabel}
        value={feedback.value}
        onValueChange={(next) => feedback.submitVote(next)}
      />
    </div>
  );
};

export default FeedbackBlock;
